import CoreResize from '../../mixins/core-resize'

import AppBtnSocialLink from '../app-btn-social-link'
import AppTextMask from '../app-text-mask'


// URL list
import URL from '../../../config.url'


export default
{
    name: 'app-footer',

    mixins:
    [
        CoreResize
    ],

    components:
    {
        AppBtnSocialLink,
        AppTextMask
    },

    props:
    {
        contentGlobal: { type: Object, default: {} }
    },

    data()
    {
        return {
            URL
        }
    },

    mounted()
    {
        this.$nextTick(() => this.$emit('load', this))
    },

    methods:
    {
        onResized()
        {
            this.$nextTick(() => this.$emit('load', this))
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-footer/script.js